/**
 * in this module there is the function that set:
 *   - the max-eight of the tools menu container
 *   - map margin-top and height
 *   - max height of search scheme and legend div
 */
 import functions from './functions'
/**
 * set the divs heights
 */
function getBrowserScale() {
  var scale = window.devicePixelRatio || 1;
  return scale;
}

// we create a function to use it later on in multiples DOM events
const sizeContent = () => {
  // maximum window height
  const viewHeight = window.innerHeight
  let navIsOpen = $('.navbar-collapse.collapse.show').length
  $('#toolbar').css('display','none')
  if (navIsOpen) {
    $('#mainNav').removeClass('show')
  }


  // navbar height
  let headHeight = $('.navbar').outerHeight()
  let navHeight = $('.navbar').attr('navheight')
  if (navHeight !== undefined) {
    if (headHeight > navHeight) {
      headHeight = navHeight
    }
  }
  else {
    navHeight = headHeight
  }
  $('#toolbar').css('top',parseFloat(navHeight))
  $('#toolbar').css('display','block')
  // maximum view minus the header and the footer
  const maxHeight = parseFloat(viewHeight) - (parseFloat(headHeight))
  // toolbarsection is the div that contain the zoom buttons print and ruler
  // this part is never hidden
  let sectionHeight = $('#toolbarsection').outerHeight()
  // 180 is the height of the search input + button and upper padding
  const searchHeight = 180

  /**
   * apply correct max height of the whole tools menu container
   * 43 is the heigh of an accordion button
   * (maxHeight - ..) depends of where is located the toolbar button
   * (mobile in the header or tablet onward inside the map)
   */
  // get number of card headers
  let numCardHeads = $('.accordion-header').length
  let cardHeadHeight = $('.accordion-header').first().outerHeight()
  cardHeadHeight = cardHeadHeight * numCardHeads
  let mobAccordionHeight = (maxHeight - 10) - sectionHeight - (43 * 3)
  const deskAccordionHeight = maxHeight - sectionHeight - cardHeadHeight - 10
  let toolsHeight = $('#displayTools').outerHeight()
  /**
   * apply fixed height at the max
   * add margin top to compensate the navbar height
   */
let mapWidth = $('#page-content-wrapper').outerWidth()
let mapHeight = maxHeight
if (getBrowserScale() >=4) {
  mapHeight = 700
  mobAccordionHeight = 700
}
  $('#map').css('height', mapHeight)
  $('#map').css('width', mapWidth)
  $('.mapcontainer').css('height', mapHeight)
  $('.mapcontainer').css('width', mapWidth)

  if (functions.mobileTabletView()) {
    // limit the tools menu container
    $('#toolbar').css('max-width', mapWidth - 4)
    $('#toolbar').css('width', mapWidth - 4)
    // limit the tools menu container

    $('#toolbar').css('max-height', maxHeight)
    // limit the scheme container
    $('#schemes').css('max-height', mobAccordionHeight)
    $('#faultbody').css('max-height', mobAccordionHeight)
    $('#suspbody').css('max-height', mobAccordionHeight)
    $('#drawbody').css('max-height', mobAccordionHeight)
    // limit the search container on search
    $('#searchcont').css('max-height', mobAccordionHeight - searchHeight)
    // limit the legend height
    $('#legendBody').css('max-height', mobAccordionHeight - 30)
    $('#legend').css('max-height', mobAccordionHeight - toolsHeight)
    $('#accordion').css('max-height', mobAccordionHeight)

    if (getBrowserScale() >=4) {
      $('#copytext').css('max-height','0.4rem')
      $('#copytext').css('text-overflow','clip')
      $('h1').hide()
      let mapTop = $('.mapcontainer').offset().top
      $('#toolbar').css('top',parseFloat(mapTop))
      $('#toolbar').css('display','block')
    }    
  }
  else {
    // limit the tools width
    $('#toolbar').css('max-width', 450)
    // limit the tools menu container
    $('#toolbar').css('max-height', maxHeight - 50)
    // limit the scheme container
    $('#schemes').css('max-height', deskAccordionHeight - toolsHeight)
    $('#faultbody').css('max-height',  deskAccordionHeight - toolsHeight)
    $('#suspbody').css('max-height',  deskAccordionHeight - toolsHeight)
    $('#drawbody').css('max-height',  deskAccordionHeight - toolsHeight)
    // limit the search container on search
    $('#searchcont').css('max-height', deskAccordionHeight - searchHeight)
    // limit the legend height
    $('#legendBody').css('max-height', deskAccordionHeight -30)
    $('#legend').css('max-height', deskAccordionHeight - toolsHeight)
    $('#accordion').css('max-height', deskAccordionHeight)
  }

} // end sizeContent

const scrollContent = () => {

  if (getBrowserScale() >=4) {

    let mapTop = $('.mapcontainer').position().top
    let docScroll = $(document).scrollTop()
    let toolScroll = parseFloat(mapTop) - parseFloat(docScroll)
    $('#toolbar').css('top',parseFloat(toolScroll))
  }    

}
/**
 * EXPORT
 */

export default {
  sizeContent,
  scrollContent,
}
